import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { 
    MarginContainerStyled, 
    // MarginTextStyled 
} from '../styles/Margin';

const FooterContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding: 20px;
    font-size: 0.85rem;
    color: ${({ theme }) => theme.textSecondary};
`;

const FooterLink = styled(Link)`
    color: ${({ theme }) => theme.textSecondary};
    text-decoration: none;
    
    &:hover {
        color: ${({ theme }) => theme.primary};
        text-decoration: underline;
    }
`;

const Separator = styled.span`
    color: ${({ theme }) => theme.textSecondary};
`;

function Footer() {
    return (
        <MarginContainerStyled>
            <FooterContent>
                <span>© {new Date().getFullYear()} PropNinja</span>
                <Separator>|</Separator>
                <FooterLink to="/privacy">Privacy Policy</FooterLink>
                <Separator>|</Separator>
                <FooterLink to="/terms">Terms of Service</FooterLink>
            </FooterContent>
        </MarginContainerStyled>
    );
}

export default Footer;